<template>
    <div class="pay-page" v-loading="loading">
        <h1>Оплата парковки</h1>
        <el-row :gutter="20">
            <el-col v-if="cardId && (params || message)" :span="24">
                <el-card>
                    <h2 class="m-b-20" v-if="payd" v-html="payd" />
                    <h2 class="m-b-20" v-if="message && !payd" v-html="message" />
                    <div v-if="paramsDict" class="params">
                        <!-- eslint-disable-next-line -->
                        <div v-if="paramsDict[key]" v-for="(param, key) in params" :key="key">
                            <div>
                                <span v-if="key === 'Total'" class="params__key">{{paramsDict[key]}}:</span>
                                <span v-else>{{paramsDict[key]}}:</span>

                                <div v-if="key === 'Total'" class="params__total">
                                    {{ (param / 100).toFixed(2) }} &#8381;
                                </div>
                                <div v-else-if="!isNaN(param)">
                                    {{ (param / 100).toFixed(2) }} &#8381;
                                </div>
                                <div v-else-if="key === 'TimeExpirationCurrent'
                            || key === 'TimeExpirationAfterProlongation'
                            || key === 'LastPaymentTime'
                            || key === 'TimeExitBeforeAfterPayment'
                            || key === 'TimeEntry'
                            || key === 'TimeExitBeforeCurrent'
                            ">
                                    {{ param | date}}
                                </div>
                                <div v-else>
                                    {{param}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-button v-if="!message" class="w-100 m-t-30" type="primary" @click="pay(order)">Оплатить</el-button>
                </el-card>
            </el-col>
        </el-row>
        <div v-if="$route.query.log">
            <h1>Логи</h1>
            <div v-for="(error, key) in errors" :key="key"><b>{{error.time}}:</b> {{error.msg}}</div>
        </div>
    </div>
</template>

<script>
const md5 = require('md5')

export default {
    data () {
        return {
            loading: false,
            cardId: (this.$route.query.cardId ? this.$route.query.cardId : ''),
            params: '',
            order: {
                amount: 0.00,
                currency: 'RUB',
                order_number: '',
                description: 'Оплата по договору парковки'
            },
            paramsDict: {},
            cards: [],
            cars: [],
            loadingCards: false,
            message: '',
            token: '',
            tokenMd5: '',
            payd: '',
            errors: []
        }
    },
    created () {
        this.logs({ 'token': sessionStorage.getItem('token') })
        sessionStorage.removeItem('token')
        this.logs('Очистили токен')
        let request = {
            Name: 'Login',
            OperatorName: '',
            OperatorPassword: ''
        }
        this.logs(request)
        this.logs('Отправляем логин')
        this.$api.Auth.login(request).then(response => {
            this.logs('Авторизовались')
            this.logs(response)
            this.token = response.Token
            this.logs('Сохранили токен ' + response.Token)
            this.tokenMd5 = md5('parktime ' + response.Token)
            sessionStorage.setItem('loginType', response.LoginType)
            sessionStorage.setItem('token', response.Token)
            this.logs('Сохранили токен ' + response.Token)

            if (this.$route.query.cardId) {
                this.logs('Поиск карты')
                this.searchCard()
            }
        }).catch (() => {
            this.logs('ОШИБКА АВТОРИЗАЦИИ')
        })
    },
    methods: {
        logs (msg) {
            this.errors.push({ time: this.$moment().format('HH:mm:ss'), msg: msg })
        },
        pay (order) {
            this.logs('Нажали кнопку оплаты')
            // eslint-disable-next-line no-undef
            ipayCheckout(order, this.successPurchase, this.failedPurchase)
        },
        successPurchase () {
            this.logs('Оплата успешна')
            this.registerPayment()
        },
        registerPayment () {
            let body = {
                "Name": "RegisterPayment",
                "PaymentId": this.params.PaymentId,
                "PaymentCard": this.cardId,
                "ParkingCostResult": this.params,
                "Hash": this.tokenMd5
            }
            this.logs(body)
            this.logs('Регистрация оплаты - вызов api')
            this.$api.Pay.registerPaymentToken(body, this.token).then(response => {
                this.logs('Регистрация оплаты - получили ответ')
                if (response.Result === 'Success') {
                    this.logs('Регистрация оплаты успешно')
                    this.logs(response)
                    this.$message({ message: 'Оплата успешно зарегистрирована', type: 'success' })

                    this.payd = 'Принято <b>' + this.order.amount + ' руб.</b>'
                    this.searchCard()
                }
                // токен устарел
                else if (response.Result === 'Failed' && response.ErrorString === 'Access Denied') {
                    let request = {
                        Name: 'Login',
                        OperatorName: '',
                        OperatorPassword: ''
                    }
                    this.$api.Auth.login(request).then(response => {
                        this.token = response.Token
                        this.tokenMd5 = md5('parktime ' + response.Token)
                        this.registerPayment()
                    })
                }
                // ошибка регистрации оплаты
                else {
                    this.logs('Регистрация оплаты - ошибка')
                    let body = {
                        "Name": "RevertPayment",
                        "orderId": this.params.PaymentId,
                        "Hash": this.tokenMd5
                    }
                    this.logs('Вызов апи - отмены оплаты')
                    this.$api.Pay.reversePayment(body).then(response => {
                        this.logs('Отмена оплаты успешно')
                        this.logs(response)
                        console.log(response)
                        this.$message({ message: 'Ошибка регистрации оплаты. Свяжитесь с технической поддержкой.', type: 'error' })
                        this.searchCard()
                    })
                }
            })
        },
        failedPurchase () {
            let body = {
                "Name": "FailedPayment",
                "PaymentId": this.params.PaymentId,
                "PaymentCard": this.cardId,
                "ParkingCostResult": this.params,
                "Hash": this.tokenMd5
            }
            this.$api.Pay.failedPayment(body).then(response => {
                this.logs('Ошибка оплаты - отправлено')
                this.logs(response)
                console.log(response)
            })

            this.$message({ message: 'Ошибка оплаты', type: 'error' })
            this.searchCard()
        },
        searchCard () {
            if (!this.cardId) {
                this.logs('Карта не передана')
                this.$message({ message: 'Выберите карту для оплаты', type: 'error' })
                return
            }

            this.loading = true

            let body = {
                Name: 'GetParkingCost',
                ItemId: this.cardId,
                Hash: this.tokenMd5,
                ItemProperties: []
            }

            let uri = window.location.search.substring(1)
            let params = new URLSearchParams(uri)
            for (let row of params.entries()) {
                body.ItemProperties.push({
                    ItemPropertyName: row[0],
                    ItemPropertyValue: row[1]
                })
            }
            this.logs(body)

            this.$api.Pay.getParkingCost(body).then(response => {
                this.logs('Получили данные карты')
                this.logs(response)
                if (response.Result !== 'Failed') {
                    this.order.amount = response.Total / 100
                    this.order.order_number = response.PaymentId

                    this.params = response
                    this.params.CardId = this.cardId
                    this.message = ''
                    this.paramsDict = {}

                    switch (response.Type) {
                        case 0:
                            this.message = 'Парковка не принимает оплаты в личном кабинете, воспользуйтесь кассовым терминалом'
                            break
                        case 1:
                            this.message = 'Оплата не требуется. Бесплатный тариф'
                            break
                        case 2:
                            this.paramsDict = {
                                Total: 'К оплате',
                                CardId: 'Номер карты',
                                TimeExitBeforeAfterPayment: 'После приема оплаты выезд до',
                                TimeEntry: 'Въезд',
                                LastPaymentTime: 'Последняя оплата',
                                Paid: 'Сумма предыдущих оплат',
                                Debt: 'Задолженность за стоянки в других зонах',
                                Discount: 'Сумма скидок',
                            }
                            break
                        case 3:
                            this.paramsDict = {
                                Total: 'К оплате',
                                CardId: 'Номер абонемента',
                                TimeExpirationCurrent: 'Срок действия абонемента до продления',
                                TimeExpirationAfterProlongation: 'Срок действия абонемента после продления',
                            }
                            break
                        case 4:
                            this.message = 'Произошла ошибка, обратитесь в администрацию парковки'
                            break
                        case 5:
                            this.message = 'Оплата не требуется'
                            this.paramsDict = {
                                CardId: 'Номер карты',
                                TimeExitBeforeCurrent: 'Выезд до'
                            }
                            break
                        default:
                            break
                    }
                    this.loading = false
                }
                else {
                    this.$message({ message: 'Ошибка получения данных карты', type: 'error' })
                    this.message = 'Ошибка получения данных карты'
                    this.params = ''
                    this.loading = false
                }
            }).catch ((err) => {
                this.$message({ message: 'Ошибка получения данных карты', type: 'error' })
                this.message = 'Ошибка получения данных карты <div><small>' + err.ErrorString + '</small>'
                this.loading = false
            })
        }
    }
}

</script>

<style scoped>

</style>
